module.exports = __webpack_public_path__ + "static/8-8fe14d07b9a823cd916fe3c9873f412f.jpg";